export const RoleCardIcon = ({
  color = 'rgba(255, 255, 255, 0.3)',
  size = 24,
}: {
  color?: string
  size?: number
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <g>
        <path
          d="M22 12L22 7.5C22 5.84314 20.6569 4.5 19 4.5L5 4.5C3.34315 4.5 2 5.84315 2 7.5L2 16.5C2 18.1569 3.34315 19.5 5 19.5L12 19.5"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.65039 6.79688C10.4042 6.79709 11.8261 8.21884 11.8262 9.97266C11.8262 10.862 11.4591 11.6647 10.8701 12.2412C12.2068 13.0107 13.1073 14.4526 13.1074 16.1055C13.1073 16.5194 12.7713 16.8552 12.3574 16.8555C11.9433 16.8555 11.6075 16.5196 11.6074 16.1055C11.6073 14.4727 10.2832 13.1486 8.65039 13.1484C7.01747 13.1484 5.69349 14.4726 5.69336 16.1055C5.69324 16.5196 5.35748 16.8555 4.94336 16.8555C4.52922 16.8555 4.19348 16.5196 4.19336 16.1055C4.19345 14.4528 5.09342 13.0108 6.42969 12.2412C5.84074 11.6647 5.47461 10.8619 5.47461 9.97266C5.47468 8.21875 6.89649 6.79695 8.65039 6.79688ZM8.65039 8.29688C7.72492 8.29695 6.97468 9.04718 6.97461 9.97266C6.97461 10.8982 7.72487 11.6484 8.65039 11.6484C9.57579 11.6482 10.3262 10.8981 10.3262 9.97266C10.3261 9.04727 9.57575 8.29709 8.65039 8.29688Z"
          fill={color}
        />
        <path
          d="M18.9319 14.7795C20.2411 14.7797 21.3028 15.8414 21.303 17.1506V17.509C22.1602 17.8267 22.7717 18.6497 22.7717 19.6174V20.6692C22.7716 21.9117 21.7643 22.9192 20.5217 22.9192H17.3411C16.0986 22.9191 15.0912 21.9116 15.0911 20.6692V19.6174C15.0911 18.6494 15.7032 17.8255 16.5608 17.5081V17.1506C16.561 15.8413 17.6225 14.7795 18.9319 14.7795ZM17.3411 18.8674C16.9269 18.8675 16.5911 19.2033 16.5911 19.6174V20.6692C16.5912 21.0832 16.927 21.4191 17.3411 21.4192H20.5217C20.9358 21.4192 21.2716 21.0833 21.2717 20.6692V19.6174C21.2717 19.2032 20.9359 18.8675 20.5217 18.8674H17.3411ZM18.9319 16.2795C18.451 16.2795 18.061 16.6698 18.0608 17.1506V17.3674H19.803V17.1506C19.8028 16.6699 19.4126 16.2797 18.9319 16.2795Z"
          fill={color}
        />
        <path
          d="M14.1194 8.94824H18.6472"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.4921 11.6667L18.6472 11.6667"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}
